import { cn } from "@shared-kernel/primary/shared/shadcn/utils/utils";

interface Props {
  current: number;
  threshold: number;
  mode: "max" | "min";
  suffix?: string;
  "data-testid"?: string;
}

const getMaxColorClass = (current: number, max: number): string => {
  const ratio = current / max;
  if (ratio >= 1) return "text-red-600";
  if (ratio >= 0.9) return "text-orange-500";
  if (ratio >= 0.75) return "text-amber-500";
  return "text-muted-foreground";
};

const getMinColorClass = (current: number, min: number): string => (current < min ? "text-red-600" : "text-muted-foreground");

export const FieldLimitCounter = ({ current, threshold, mode, suffix, "data-testid": testId }: Props) => {
  const colorClass = mode === "max" ? getMaxColorClass(current, threshold) : getMinColorClass(current, threshold);
  const isColored = colorClass !== "text-muted-foreground";
  return (
    <span className={cn("shrink-0 text-xs tabular-nums", colorClass, isColored && "font-semibold")} data-testid={testId}>
      {current}/{threshold}
      {suffix ? ` ${suffix}` : ""}
    </span>
  );
};
